import React from "react";

export default function NotesPanel({
  notes,
  onChange,
  onSave,
  isSaving,
  feedback,
  isSaveDisabled,
}) {
  return (
    <section className="dialer-notes-panel">
      <div className="dialer-panel-header">
        <div>
          <h3 className="dialer-panel-title">Notes</h3>
        </div>
        <button
          type="button"
          className="dialer-primary-button"
          onClick={onSave}
          disabled={isSaving || isSaveDisabled}
        >
          {isSaving ? "Saving..." : "Save Notes"}
        </button>
      </div>

      <div className="dialer-notes-body">
        <label htmlFor="dialer-notes-textarea" className="dialer-form-label">
          Call summary
        </label>
        <textarea
          id="dialer-notes-textarea"
          className="dialer-textarea"
          value={notes}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Document key details, next steps, and follow-ups."
        />

        {feedback ? (
          <div className="dialer-inline-feedback">{feedback}</div>
        ) : null}
      </div>
    </section>
  );
}
